export default "__VITE_ASSET__C6BaJsEK__"